import React from 'react';
import { useIntl } from 'react-intl';
import {
  Typography,
  withStyles,
} from '@material-ui/core';
import { bool, object } from 'prop-types';

import styles from './styles';
import { getI18n } from '../../../../utils/intl';

export const RoleInfoDialogContent = (props) => {
  const {
    classes,
    isPortalAdmin,
  } = props;
  const intl = getI18n(useIntl());

  return (
    <div className={classes.userRoleInfoContent}>
      {isPortalAdmin &&
        (<>
          <Typography variant='h4'>
            {intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.usertypes')}
          </Typography>
          <ul>
            <li>{intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.usertypes.1')}</li>
            <li>{intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.usertypes.2')}</li>
          </ul>
          <Typography variant='h4'>
            {intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.globaluser.roles')}
          </Typography>
          <ul>
            <li>{intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.globaluser.roles.1')}</li>
            <li>{intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.globaluser.roles.2')}</li>
          </ul>
        </>)
      }
      <Typography variant='h4'>
        {intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.orguser.roles')}
      </Typography>
      <ul>
        <li>{intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.orguser.roles.1')}</li>
        <li>{intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.orguser.roles.2')}</li>
        <li>{intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.orguser.roles.3')}</li>
      </ul>
      <Typography variant='h4'>
        {intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.workflow')}
      </Typography>
      <p>
      {intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.workflow.1')}
      </p>
      <ul>
        <li>{intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.workflow.1.1')}</li>
        <li>{intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.workflow.1.2')}</li>
      </ul>
      <p>
      {intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.workflow.2')}
      </p>
      <ul>
        <li>{intl.getI18nFormattedMessage('label.user.details.userroles.info.dialog.section.workflow.2.1')}</li>
      </ul>
    </div>
  );
};

RoleInfoDialogContent.propTypes = {
  classes: object,
  isPortalAdmin: bool,
}

export default withStyles(styles)(RoleInfoDialogContent);
